import React, { useState } from 'react';

import PivotTableUI from '@datatox-bi/pivottable';
import TableRenderers from '@datatox-bi/pivottable/TableRenderers';
import '@datatox-bi/pivottable/pivottable.css';
import MuiAgg from './MuiAgg';

export default function TabelaDinamica({
    ref,
    dataset = [],
    metaAtributos,
    headers = [],
    aggregatorName,
    vals,
    enablePercentage = false,
    aggregatorList,
    rows,
    cols,
    rowOrder = 'value_a_to_z',
}) {
    const [pivotState, setPivotState] = useState(null);
    dataset[0] = headers;
    return (
        <PivotTableUI
            // hiddenAttributes={hiddenAttributes}
            data={dataset}
            meta={metaAtributos}
            enableRowNumbers={false}
            unusedOrientationCutoff={Infinity}
            renderers={Object.assign({}, TableRenderers)}
            onChange={(s) => setPivotState(s)}
            rows={rows}
            cols={cols}
            aggregatorName={aggregatorName}
            enablePercentage={enablePercentage}
            // hiddenAttributes={['f_paciente_faixa_etaria_ord']}
            vals={vals}
            aggregatorList={aggregatorList}
            rowOrder={rowOrder} // key_a_to_z
            // colOrder="value_a_to_z"
            {...pivotState}
            ComponentAgg={MuiAgg}
        />
    );
}
